import { useLocation } from "react-router-dom";

/** Clears the fixed nav (and the fixed Back bar where it appears) so page content starts below them. */
export const NavSpacer = () => {
  const { pathname } = useLocation();
  const hasBackBar = pathname !== "/" && !pathname.startsWith("/admin");

  return (
    <div
      aria-hidden="true"
      data-testid="nav-spacer"
      className={hasBackBar ? "h-[104px] md:h-[112px]" : "h-[62px] md:h-[70px]"}
    />
  );
};
